import React, { useEffect, useRef, useState } from 'react';
import './admin-manage-games-landing.styles.scss';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import AdminGameView from './admin-game-view.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { getQueryFromFirestore, getQueryFromRtDb } from '@/utils/getDataFromDbSimplified';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';
import { properCase } from '@/utils/properCase';

const AdminManageGamesLanding = ({
  owners
}) => {

  const [ gamesToDisplay, setGamesToDisplay ] = useState(null);
  const [ gamesIndex, setGamesIndex ] = useState(null);
  const [ searchTerm, setSearchTerm ] = useState('');
  const [count, setCount] = useState(15);
  const navigate = useNavigate();
  const gamesRef = useRef({});
  let gamesListener;

  useEffect(() => {
    getGames();
    getGamesIndex();
    changeDocumentTitle('Gamably Admin | Manage Games');

    return () => {
      if (gamesListener) gamesListener();
    }
  }, [])

  async function getGames() {
    getQueryFromFirestore({
      'path': 'games',
      'orderBy': {
        'field': 'ts',
        'direction': 'desc'
      },
      'loadLimit': count,
      'callback': callback,
      'handleListener': handleListener,
    })
    function callback(data, id) {
      const owner = owners ? owners[data.creatorId] : null;
      const newData = {
        ...data,
        ...{'owner': owner}
      }
      gamesRef.current = {
        ...gamesRef.current,
        ...{ [id]: newData }
      }
      setGamesToDisplay(Object.values(gamesRef.current));
    }
    function handleListener(unsub) {
      gamesListener = unsub;
    }
  }

  async function getGamesIndex() {
    getQueryFromRtDb({
        'path': 'gamesIndex',
        'once': true,
        'callback': callback
    })
    function callback(data) {
      const newIndexList = {};
      for (let gameId in data) {
        const gameData = data[gameId];
        const owner = owners ? owners[gameData.creatorId] : null;
        newIndexList[gameId] = {
          ...gameData,
          ...{'owner': owner}
        }
      }
      console.log(data);
      setGamesIndex(newIndexList);
    }
  }

  useEffect(() => {
    if (!gamesIndex) return;
    search();
  }, [searchTerm, gamesIndex]);

  function search() {
    // const searchTerm = document.getElementById('games_search_input').value.toLowerCase();
    if (!searchTerm) {
      setGamesToDisplay(Object.values(gamesRef.current));
      return;
    }
    const filteredGames = Object.values(gamesIndex)
    .filter(g => 
      g.gameName.toLowerCase().includes(searchTerm) ||
      g.owner?.fName.toLowerCase().includes(searchTerm) ||
      g.owner?.lName.toLowerCase().includes(searchTerm) ||
      g.path.toLowerCase().includes(searchTerm) ||
      g.gameId.toLowerCase().includes(searchTerm)
    );
    setGamesToDisplay(filteredGames);
  }

  async function loadMore() {
    const lastGame = gamesToDisplay[gamesToDisplay.length - 1];
    getQueryFromFirestore({
      'path': 'games',
      'orderBy': {
        'field': 'ts',
        'direction': 'desc'
      },
      'loadLimit': 10,
      'queryArray': [
        {
            'field': 'ts',
            'operator': '<',
            'value': lastGame.ts
        }
      ],
      'callback': callback,
      'once': true
    })
    function callback(data, id) {
      if (!data) return;
      gamesRef.current = {
        ...gamesRef.current,
        ...data
      }
      setGamesToDisplay(Object.values(gamesRef.current));
    }
  }

  return (
    <div className='manage-games-landing'>
      <Routes>
        <Route path='' element={
          <div className='manage-games-content g-card'>
            <div className='section-title'>
              <span>Manage Games</span>
            </div>
            <hr />
            <div className='search-container'>
              <SearchBar search={e => setSearchTerm(e)} idLabel='games_search_input' />
            </div>
            <div className="g-space-1"></div>

            {
              (gamesToDisplay && owners)
                ?
                <table className='g-table'>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Owner</th>
                      <th>Status</th>
                      <th>Activity</th>
                      <th>Elements</th>
                      <th>Players</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      gamesToDisplay
                        .sort((a, b) => a.ts < b.ts ? 1 : -1)
                        .map(g => {
                          // const owner = owners[g.creatorId]
                          return (
                            <tr 
                              key={g.gameId}
                              className={g.template ? 'template' : g.status}>
                              <td className='game-icon'>
                                {
                                  (g.icon)
                                  ?
                                  <ImageContainer
                                    src={g.icon}
                                  />
                                  :
                                  <div className='placeholder-icon'>
                                    {g.gameName[0]}
                                  </div>
                                }
                              </td>
                              <td>
                                <Link to={g.gameId}>
                                  {g.gameName}
                                </Link>
                              </td>
                              <td>{
                                g.owner
                                  ?
                                  `${g.owner.fName} ${g.owner.lName}`
                                  :
                                  'Unknown'
                              }</td>
                              <td>{g.template ? 'TEMPLATE' : properCase(g.status)}</td>
                              <td>{g.ts ? format(new Date(g.ts), "P") : 'N/A'}</td>
                              <td>{g.createdElementTotal ?? 0}</td>
                              <td>{g.playerCount ?? 0}</td>
                              <td>
                                <div className="buttons">
                                  <button
                                    className='g-button small-btn'
                                    onClick={() => navigate(g.gameId)} >
                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          )
                        })
                    }
                  </tbody>
                </table>
                :
                <div className='center-col'>
                  <ThreeDotsLoader />
                </div>
            }
            {
              (!searchTerm) &&
              <>
              <div className="g-space-1"></div>
              <div className='center'>
                <button
                  className='g-button med-btn'
                  onClick={loadMore}
                >
                  Load More...
                </button>
              </div>
              </>
            }
          </div>
        }></Route>
        <Route path=':gameId/*' element={
          <AdminGameView
            games={gamesRef.current}
            owners={owners} />
        }></Route>
      </Routes>
    </div>
  )
}

export default AdminManageGamesLanding